(function (root, factory) {
        if (typeof define === 'function' && define.amd) {
            // AMD. Register as an anonymous module.
            define([], factory);
        } else if (typeof module === 'object' && module.exports) {
            // Node. Does not work with strict CommonJS, but
            // only CommonJS-like environments that support module.exports,
            // like Node.
            module.exports = factory();
        } else {
            // Browser globals (root is window)
            root.returnExports = factory();
        }
    }(typeof self !== 'undefined' ? self : this, function () {
        // Just return a value to define the module export.
        // This example returns an object, but the module
        // can return a function as the exported value.
        'use strict';
        var skins = {};
         skins['wysiwyg.common.components.radio.viewer.skins.RadioButtonDefaultSkin'] = {
  "react": [
    [
      "label",
      "container",
      [],
      {},
      [
        "input",
        "radio-input",
        [],
        {
          "type": "radio",
          "tabIndex": 0
        }
      ],
      [
        "div",
        "circle-shadow",
        [],
        {},
        [
          "div",
          "circle",
          [],
          {}
        ]
      ],
      [
        "div",
        "text",
        [],
        {}
      ]
    ]
  ],
  "params": {
    "bge": "BG_COLOR_ALPHA",
    "bg3e": "BORDER_COLOR_ALPHA",
    "brw": "BORDER_SIZE",
    "bg3d": "BG_COLOR_ALPHA",
    "bg": "BG_COLOR_ALPHA",
    "bg3": "BORDER_COLOR_ALPHA",
    "bg2": "BG_COLOR_ALPHA",
    "shd": "BOX_SHADOW",
    "bgf": "BG_COLOR_ALPHA",
    "border_color_focus": "BORDER_COLOR_ALPHA",
    "border_width_focus": "BORDER_SIZE",
    "bgh": "BG_COLOR_ALPHA",
    "bg3h": "BORDER_COLOR_ALPHA",
    "brwh": "BORDER_SIZE",
    "bg2h": "BG_COLOR_ALPHA",
    "bgd": "BG_COLOR_ALPHA",
    "brdd": "BORDER_COLOR_ALPHA",
    "fnt": "FONT",
    "txt": "TEXT_COLOR"
  },
  "paramsDefaults": {
    "bge": "color_15",
    "bg3e": "color_14",
    "brw": "1px",
    "bg3d": "color_14",
    "bg": "color_15",
    "bg3": "color_14",
    "bg2": "color_11",
    "shd": "0 0px 0px rgba(0, 0, 0, 0)",
    "bgf": "color_15",
    "border_color_focus": "#CCC",
    "border_width_focus": "1px",
    "bgh": "color_15",
    "bg3h": "color_14",
    "brwh": "1px",
    "bg2h": "color_11",
    "bgd": "color_15",
    "brdd": "#CCCCCC",
    "fnt": "font_8",
    "txt": "color_15"
  },
  "css": {
    "%_with-validation-indication%_invalid %container %circle-shadow": "background-color:[bge];border:solid [bg3e] [brw];",
    "%_with-validation-indication%_invalid %container %circle-shadow %circle": "background-color:[bg3d];",
    "%container": "display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;",
    "%container %circle-shadow": "background-color:[bg];border:solid [bg3] [brw];[shd]    border-radius:50%;position:relative;box-sizing:border-box;",
    "%container %circle-shadow %circle": "background-color:[bg2];",
    "%container %circle": "opacity:0;border-radius:50%;height:50%;width:50%;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%);",
    "%container input:checked + %circle-shadow %circle": "opacity:1;",
    "%container input": "position:absolute;opacity:0;",
    "%container input:focus + %circle-shadow": "background-color:[bgf];border:solid [border_color_focus] [border_width_focus];",
    "%container input:focus + %circle-shadow %circle": "background-color:[bg2];",
    "%container:hover %circle-shadow,%container[data-preview~=\"hover\"] %circle-shadow": "background-color:[bgh];border:solid [bg3h] [brwh];",
    "%container:hover %circle-shadow %circle,%container[data-preview~=\"hover\"] %circle-shadow %circle": "background-color:[bg2h];",
    "%container[data-preview~=\"focus\"] %circle-shadow": "background-color:[bgf];border:solid [border_color_focus] [border_width_focus];",
    "%container[data-preview~=\"focus\"] %circle-shadow %circle": "background-color:[bg2];",
    "%container[data-error=\"true\"] %circle-shadow,%container[data-preview~=\"error\"] %circle-shadow": "background-color:[bge];border:solid [bg3e] [brw];",
    "%container[data-error=\"true\"] %circle-shadow %circle,%container[data-preview~=\"error\"] %circle-shadow %circle": "background-color:[bg3d];",
    "%container[data-disabled=\"true\"] %circle-shadow,%container[data-preview~=\"disabled\"] %circle-shadow": "background-color:[bgd];border:solid [brdd] [brw];",
    "%container[data-disabled=\"true\"] %circle-shadow %circle,%container[data-preview~=\"disabled\"] %circle-shadow %circle": "background-color:[bg3d];",
    "%_right-direction": "display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-webkit-flex-direction:row-reverse;flex-direction:row-reverse;",
    "%_right-direction %text,%_right-direction %container": "direction:rtl;",
    "%_left-direction": "display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:reverse;-webkit-flex-direction:reverse;flex-direction:reverse;",
    "%_left-direction %text,%_left-direction %container": "direction:ltr;",
    "%text": "[fnt]  color:[txt];word-break:break-word;display:inline-block;line-height:1;"
  }
}

        return skins;
    }));